// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root{
  margin-top: 130px;
}
 
.form-row {
  display: flex;
  gap: 16px;
}

.flex-item {
  flex: 1 1;
 
}
 
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  

  
  .table-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .search-input {
    width: 40%;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .styled-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px 15px;
  }
  
  .styled-table th {
    background-color: #f3f4f6;
    color: #333;
  }
  
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .clickable-row:hover {
    background-color: #f1f1f1;
  }
  
  .expanded-content {
    padding: 10px;
    background-color: #e9e9e9;
    border-radius: 4px;
  }
  
  .pagination-controls {
    text-align: center;
  }
  
  .pagination-controls button {
    padding: 8px 12px;
    margin: 0 5px;
    border: none; 
    background-color: #ff6f61;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-controls button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  


  .btndoweload {
    background-color: #F3903F; /* Orange */
    color: white; /* White text */
    font-weight: semibold;
    padding: 5px 5px;
      size: 16px;
      height: 40px;
    border-radius: 5px;
    border: none;
    transition:  0.3s ease, transform 0.2s ease;
  }
  .btn-upload {
    background-color: transparent; /* Transparent background */
    color: #F3903F; /* Orange text */
    font-weight: semibold;
    padding: 5px 5px;
    size: 16px;
    height: 40px;
    border-radius: 5px;
    border: 2px solid #F3903F; /* Orange border */
    transition: 0.3s ease, transform 0.2s ease;
  }

  .btn-upload:hover {
    background-color: #F3903F; /* Orange background on hover */
    color: white; /* White text on hover */
  }

  .btn-create {
    background-color: #F3903F; 
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    padding: 8px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;
  }
  
  .btn-create:hover:enabled {
    background-color: #d6792f; 
    transform: translateY(-1px);
  }
  
  .btn-create:disabled {
    background-color: #e0e0e0;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
  }


  .submit-button4 {
    
    border: none;
    background-color: #ff6f61;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button4:hover {
    outline: none;
    background-color: #e65c54;
  }



  .submit-button5 {
    
    background-color: transparent;
    border: 1px solid #ff6f61;
    color: #ff6f61;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 30px !important;
  }
  
  .submit-button5:hover {
    outline: none;
    background-color: #e65c54;
    color: white;
  }


  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

.action-button,
.action-button-success,
.action-button-info,
.action-button-danger {
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
  padding: 6px;
  border-radius: 6px;
}

.action-button:hover,
.action-button-success:hover,
.action-button-info:hover,
.action-button-danger:hover {
  transform: scale(1.1);
  background-color: #f0f0f0;
}

.action-button-success:hover {
  background-color: #d4edda;
}
.action-button-info:hover {
  background-color: #d1ecf1;
}
.action-button-danger:hover {
  background-color: #f8d7da;
}


  .action-button-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-without-border:hover{
    background-color: rgba(150, 214, 241, 0.87);
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/AllSurveys/surveys.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;;AAET;;EAEE;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;;;EAIA;IACE,yBAAyB,EAAE,WAAW;IACtC,YAAY,EAAE,eAAe;IAC7B,qBAAqB;IACrB,gBAAgB;MACd,UAAU;MACV,YAAY;IACd,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,6BAA6B,EAAE,2BAA2B;IAC1D,cAAc,EAAE,gBAAgB;IAChC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,kBAAkB;IAC7C,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;IAC1D,YAAY,EAAE,wBAAwB;EACxC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8EAA8E;EAChF;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;EACd;;;EAGA;;IAEE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;;;EAIA;;IAEE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;AAEF;;;;EAIE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,2DAA2D;EAC3D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;;EAGE;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2CAA2C;EAC7C","sourcesContent":["\n.root{\n  margin-top: 130px;\n}\n \n.form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.flex-item {\n  flex: 1;\n \n}\n \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: center;\n  }\n  \n  .table tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n\n  \n  .table-title {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n  }\n  \n  .search-input {\n    width: 40%;\n    padding: 10px;\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n  }\n  \n  .styled-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .styled-table th,\n  .styled-table td {\n    padding: 12px 15px;\n  }\n  \n  .styled-table th {\n    background-color: #f3f4f6;\n    color: #333;\n  }\n  \n  .clickable-row {\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .clickable-row:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .expanded-content {\n    padding: 10px;\n    background-color: #e9e9e9;\n    border-radius: 4px;\n  }\n  \n  .pagination-controls {\n    text-align: center;\n  }\n  \n  .pagination-controls button {\n    padding: 8px 12px;\n    margin: 0 5px;\n    border: none; \n    background-color: #ff6f61;\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .pagination-controls button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n  }\n  \n\n\n  .btndoweload {\n    background-color: #F3903F; /* Orange */\n    color: white; /* White text */\n    font-weight: semibold;\n    padding: 5px 5px;\n      size: 16px;\n      height: 40px;\n    border-radius: 5px;\n    border: none;\n    transition:  0.3s ease, transform 0.2s ease;\n  }\n  .btn-upload {\n    background-color: transparent; /* Transparent background */\n    color: #F3903F; /* Orange text */\n    font-weight: semibold;\n    padding: 5px 5px;\n    size: 16px;\n    height: 40px;\n    border-radius: 5px;\n    border: 2px solid #F3903F; /* Orange border */\n    transition: 0.3s ease, transform 0.2s ease;\n  }\n\n  .btn-upload:hover {\n    background-color: #F3903F; /* Orange background on hover */\n    color: white; /* White text on hover */\n  }\n\n  .btn-create {\n    background-color: #F3903F; \n    color: #fff;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 8px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    outline: none;\n    transition: background-color 0.3s ease, transform 0.2s ease, opacity 0.2s ease;\n  }\n  \n  .btn-create:hover:enabled {\n    background-color: #d6792f; \n    transform: translateY(-1px);\n  }\n  \n  .btn-create:disabled {\n    background-color: #e0e0e0;\n    color: #999;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n\n\n  .submit-button4 {\n    \n    border: none;\n    background-color: #ff6f61;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    outline: none;\n    height: 30px !important;\n  }\n  \n  .submit-button4:hover {\n    outline: none;\n    background-color: #e65c54;\n  }\n\n\n\n  .submit-button5 {\n    \n    background-color: transparent;\n    border: 1px solid #ff6f61;\n    color: #ff6f61;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    outline: none;\n    height: 30px !important;\n  }\n  \n  .submit-button5:hover {\n    outline: none;\n    background-color: #e65c54;\n    color: white;\n  }\n\n\n  .loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 9999;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n.action-button,\n.action-button-success,\n.action-button-info,\n.action-button-danger {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n  padding: 6px;\n  border-radius: 6px;\n}\n\n.action-button:hover,\n.action-button-success:hover,\n.action-button-info:hover,\n.action-button-danger:hover {\n  transform: scale(1.1);\n  background-color: #f0f0f0;\n}\n\n.action-button-success:hover {\n  background-color: #d4edda;\n}\n.action-button-info:hover {\n  background-color: #d1ecf1;\n}\n.action-button-danger:hover {\n  background-color: #f8d7da;\n}\n\n\n  .action-button-without-border{\n    padding: 2px 3px;\n    margin-right: 5px;\n    border: none; \n    background-color: transparent;\n    color: rgb(236, 26, 26);\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .action-button-without-border:hover{\n    background-color: rgba(150, 214, 241, 0.87);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
